<template>
<div id="map-container">
  <canvas id="distribution-chart"></canvas>
  <div class="row align-items-center">
    <label for="time_unit" class="col-form-label col-sm-2 text-end">Showed by</label>
    <div class="col-sm-10">
      <select v-model="time_unit" @change="create_chart(null)" class="form-select form-select-sm">
        <option value="day">Day</option>
        <option value="week">Week</option>
        <option value="month">Month</option>
        <option value="year">Year</option>
      </select>
    </div>
  </div>
</div>
</template>

<script>
import Chart from 'chart.js/auto';
import moment from "moment";
import "chartjs-adapter-moment";

export default {
  name: "distribution-chart",
  data() {
    return {
      events: [],
      time_unit: "week",
    }
  },
  mounted() {
  },
  methods: {
    create_chart(events) {
      if (events == null)
        events = this.events;
      else
        this.events = events;

      const data = this.load_publication_chart_data(events);
      
      let chart = Chart.getChart('distribution-chart'); 

      if (chart != null) {
        chart.data.datasets = data;
        chart.update();
        return;
      }

      const canvas_element = document.getElementById('distribution-chart');
      if (canvas_element == null) {
        console.log("canvas_element is null");
        return;
      }
      const ctx = canvas_element.getContext("2d");
      
      chart = new Chart(ctx, {
        type: 'bar',
        options: {
          responsive: true,
          scales: {
            x: {
              stacked: true,
              type: 'time',
              time: {
                unit: this.time_unit,
              },
              title: {
                display: true,
                text: 'Time'
              }
            },
            y: {
              stacked: true,
              beginAtZero: true,
              title: {
                display: true,
                text: 'Count'
              }
            }
          }
        },
        data: {
          datasets: data
        }
      });
    },
    load_publication_chart_data(events) {
      var data = {};
      for (var i = 0; i < events.length; i++) {
        const event = events[i];
        const date = event.data.event_date[0].value;
        const source = event.source;

        if (!data[date]) {
          data[date] = {};
        }
        if (!data[date][source]) {
          data[date][source] = 0;
        }
        data[date][source] += 1;
      }
      
      var data_array = [];
      for (const [date, sources] of Object.entries(data)) {
        for (const [source, count] of Object.entries(sources)) {
          data_array.push({x: date, y: count, source: source});
        }
      }
      
      data_array = this.sum_by_time(data_array, this.time_unit);

      return this.format_chart_data(data_array);
    },
    sum_by_time(data, timeUnit) {
      const formatMap = {
        'day': 'YYYY-MM-DD',
        'week': 'YYYY-[W]WW',
        'month': 'YYYY-MM',
        'year': 'YYYY',
      };

      const totals = {};

      data.forEach((datum) => {
        const date = moment(datum.x).format(formatMap[timeUnit]);
        const source = datum.source;

        if (!totals[date]) {
          totals[date] = {};
        }
        if (!totals[date][source]) {
          totals[date][source] = 0;
        }
        totals[date][source] += datum.y;
      });

      const result = [];
      for (const [date, sources] of Object.entries(totals)) {
        for (const [source, count] of Object.entries(sources)) {
          result.push({x: date, y: count, source: source});
        }
      }

      return result;
    },
    format_chart_data(data) {
      const datasets = {};
      const source_info_map = {};
      $data_sources.forEach(source => {
        source_info_map[source.name] = source;
      });

      data.forEach(datum => {
        if (!datasets[datum.source]) {
          const source_info = source_info_map[datum.source];
          if (source_info) {
            datasets[datum.source] = {
              label: source_info.name,
              backgroundColor: source_info.html_color,
              data: []
            };
          }
        }
        if (datasets[datum.source]) {
          datasets[datum.source].data.push({x: datum.x, y: datum.y});
        }
      });

      return Object.values(datasets);
    }
  }
}
</script>

<style scoped>
</style>